import compose from "ramda/es/compose";
import curry from "ramda/es/curry";
import filter from "ramda/es/filter";
import join from "ramda/es/join";
import not from "ramda/es/not";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
/**
 * join non null values to string
 *
 * @documented
 * @category Function
 *
 */ const joinString = curry((separator, values)=>{
    const joinedStrings = join(separator, filter(compose(not, isNilOrEmpty), values ?? []));
    return joinedStrings === separator ? '' : joinedStrings;
});
export default joinString;
